import { Button, Row, Select } from 'antd'
import POAndPayPlanForm from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/POAndPayPlan/POAndPayPlanForm'
import CSVExportButton from '../../../../../../elements/Buttons/csvExportButton'
import DateCell from '../../../../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import React from 'react'
import { Link } from 'react-router-dom'
import SumFooter from '../../../../../../elements/Table/Footers/SumFooter'
import { get, groupBy } from 'lodash'

function POAndPayPlanDisplay(props) {
  const { formRef, submitting, submit, data } = props
  const columns = [
    {
      Header: 'PO Code',
      accessor: 'code',
      width: 120,
      Cell: ({ value, original }) => (
        <Link target={'_blank'} to={`/purchasing/Order/${get(original, '_key')}/update`}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'PO Status',
      accessor: 'status',
      width: 120,
      hideable: true,
      hideDefault: false,
      StatusCell,
      filterMethod: (filter, row) => {
        const activeArray = ['Approved', 'Delivered', 'Resubmitted', 'Revised']
        const revisionArray = ['Draft', 'Submitted']
        const nonActiveArray = ['Rejected', 'Closed', 'Cancelled']
        if (filter.value === 'all') {
          return true
        }
        if (filter.value === 'revision') {
          return revisionArray.includes(row[filter.id])
        }
        return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({ onChange, filter }) => (
        <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : true}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>Active</Select.Option>
          <Select.Option value="revision">In Progress</Select.Option>
          <Select.Option value={false}>Not Active</Select.Option>
        </Select>
      ),
    },
    {
      Header: 'PO Date',
      accessor: 'date',
      width: 120,
      Cell: DateCell,
    },
    {
      Header: 'PO Del Date',
      accessor: 'delivery.date',
      width: 130,
      Cell: DateCell,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Total PayPan (USD)',
      accessor: 'totalConverted',
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Vendor',
      accessor: 'vendor.fn',
      width: 350,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 300,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Purchases Category',
      accessor: 'category',
      width: 80,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Purchases Currency',
      accessor: 'currency',
      width: 80,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Purchases Title',
      accessor: 'title',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Purchases Type',
      accessor: 'type',
      hideable: true,
      hideDefault: true,
    },
  ]

  const RawList = Object.values(groupBy(data, 'purchases._id'))
  const list = RawList.map((l) => {
    let newRow = { ...l[0].purchases }
    newRow.uniq = l
    newRow.totalConverted = l.reduce((acc, v) => v.payplan.amountUSD + acc, 0)
    return newRow
  })
  console.log({ list, RawList })
  const poColumns = [
    {
      Header: 'PayPlan ID',
      accessor: 'payplan._id',
      hideable: true,
      hideDefault: true,
    },
    { Header: 'PayPlan Name', accessor: 'payplan.name' },
    { Header: 'PayPlan (CUR)', accessor: 'payplan.currency' },
    { Header: 'PayPlan Amount', accessor: 'payplan.amount', Cell: MoneyCell },
    {
      Header: 'PayPlan Converted',
      accessor: 'payplan.amountUSD',
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    { Header: 'Due Date', accessor: 'payplan.date', Cell: DateCell },
    { Header: 'PayPlan Status', accessor: 'payplan.status' },
    {
      Header: 'Voucher Code',
      accessor: 'voucher.code',
      Cell: ({ value, original }) => (
        <Link target={'_blank'} to={`/purchasing/vouchers/${get(original, 'voucher._key')}/update`}>
          {value}
        </Link>
      ),
    },
    { Header: 'Voucher Due', accessor: 'voucher.dueDate', Cell: DateCell },
    {
      Header: 'scheduledDate Date',
      accessor: 'voucher.scheduledDate',
      Cell: DateCell,
      hideable: true,
      hideDefault: true,
    },

    { Header: 'Voucher Status', accessor: 'voucher.status', StatusCell },
  ]
  return (
    <>
      <Row>
        <POAndPayPlanForm ref={formRef} {...props} />
        <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
          Submit
        </Button>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <CustomTable
          data={list}
          defaultPageSize={20}
          fetching={submitting}
          fetch={submit}
          show={{ csv: { fileName: `PO-PayPlan-Voucher-Report` } }}
          isFilterable={true}
          ExtraButtons={() => (
            <CSVExportButton
              data={data}
              columns={[...columns, ...poColumns]}
              title={'Export To CSV'}
              fileName={'PO-PayPlan-Voucher-Report'}
            />
          )}
          columns={columns}
          SubComponent={(row) => (
            <div style={{ padding: '20px' }}>
              <CustomTable
                data={row.original.uniq}
                columns={poColumns}
                show={{ csv: { fileName: `-${row.original.code}` } }}
                defaultSorted={[{ id: 'payplan.name', desc: false }]}
              />
            </div>
          )}
        />
      </Row>
    </>
  )
}

export default POAndPayPlanDisplay
